// extracted by mini-css-extract-plugin
export default {"fadeIn":"StartPageStyles_fadeIn__dIdjA","fadeOut":"StartPageStyles_fadeOut__-beU7","container":"StartPageStyles_container__ylFo7"};